export const LOAD_DATA = 'LOAD_DATA'
export const LOAD_DATA_COMPLETE = 'LOAD_DATA_COMPLETE'

export const DELETE_ADMIN_DATA = 'DELETE_ADMIN_DATA'
export const DELETE_ADMIN_COMPLETE = 'DELETE_ADMIN_COMPLETE'

export default {
  LOAD_DATA,
  LOAD_DATA_COMPLETE,
  DELETE_ADMIN_DATA,
  DELETE_ADMIN_COMPLETE
}



// WEBPACK FOOTER //
// ./src/containers/Management/Admin/store/actionTypes.js